import React from "react";
import { VesselVesselContractProvider } from "../VesselVesselContractMatrix/state/vesselVesselContractContext";
import { VesselVesselContractView } from "../VesselVesselContractMatrix/components/VesselVesselContractView";

function VesselVesselContract(props) {
  return (
    <VesselVesselContractProvider>
      <VesselVesselContractView {...props} />
    </VesselVesselContractProvider>
  );
}

export default React.memo(VesselVesselContract);